import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=2c8dc52a&scoped=true&"
import script from "./attendance.vue?vue&type=script&lang=js&"
export * from "./attendance.vue?vue&type=script&lang=js&"
import style0 from "./attendance.vue?vue&type=style&index=0&id=2c8dc52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8dc52a",
  null
  
)

export default component.exports